import { AuthContext } from '@repo/utils/context';
import { useContext } from 'react';

export const useAuthContext = () => useContext(AuthContext);
